import { useRatingStatus } from "queries/ratings";
import ContainerUserRating from "components/apps/Public/UserRating/ContainerUserRating";
import FormRating from "components/apps/Public/UserRating/FormRating";
import RatingSubmitted from "components/apps/Public/UserRating/RatingSubmitted";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const UserRatingPublic = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const key = searchParams.get("key");
  const [isValidating, setIsValidating] = useState(true);
  const [ratingPage, setRatingPage] = useState(false);

  const { data, isLoading, refetch, isFetching } = useRatingStatus(key, {
    enabled: !!key,
  });

  useEffect(() => {
    if (!key || (!data && !isLoading)) {
      navigate("/p/404", { replace: true });
    } else {
      setIsValidating(false);
    }
  }, [key, data, navigate, isLoading]);

  if (isValidating) {
    return null; // atau loading spinner: return <LoadingSpinner />;
  }

  return (
    <ContainerUserRating>
      {isLoading || !data ? ( //supaya tidak ada glitch loading
        <div className="flex flex-col items-center justify-center p-8">
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
            size="large"
          />
          <div className="mt-4 text-gray-500">Mohon tunggu sebentar...</div>
        </div>
      ) : (Array.isArray(data) && data.length === 0) || ratingPage ? ( // jika rating kosong atau memang mau ubah rating
        <FormRating
          conversationKey={key}
          refetch={refetch}
          data={data}
          isLoading={isLoading || isFetching}
          setRatingPage={setRatingPage}
        />
      ) : (
        <RatingSubmitted setRatingPage={setRatingPage} data={data} />
      )}
    </ContainerUserRating>
  );
};

export default UserRatingPublic;
